import React from 'react';

class NavWrapper extends React.Component {
  render() {
    return (
      <div className="wrapper">
        {this.props.children}
      </div>
    );
  }
}

export default NavWrapper;
